// extracted by mini-css-extract-plugin
export default {"container":"_1I99PxqTaJcdNntpDbVrPy","icon":"_3R-5nwfQ9hS-s1Z0YPYNFo","centered":"_38HnkYq1CoaAbmpkIjUNdj","modalBody":"_3RavOLL2WX69zWto84VqIG","heading":"_1FDEReVXtf1ckoyQFsf34p"};